import ArticleList from 'components/articles/ArticleList';
import { MediaPlayer } from 'components/player/MediaPlayer';
import { withRouter } from 'components/shell/WithRouter';
import { ArticleTypeMap } from 'config';
import { isTimerEnabled } from 'helpers';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import HomePage from './HomePage';
import Page from './Page';

function MediaPage(props) {
	let { routeState, isModal, history } = props;
	let { href } = useParams();

	useEffect(() => {
		if (isModal) {
			isTimerEnabled().then((timerEnabled) => {
				if (routeState.type === 'dhyan' && timerEnabled) {
					MediaPlayer.instance().showTimerView();
				} else {
					MediaPlayer.instance().playAllAudio(href!, routeState.type);
				}
			});
		}
	}, [href, isModal, routeState]);

	return (
		<React.Fragment key={'media-player-' + href}>
			{!isModal ? (
				<Page
					title={ArticleTypeMap[routeState.type]}
					includeBottomNavigation
					fullscreen
					dark
					onLoad={async () => {
						let timerEnabled = await isTimerEnabled();
						if (routeState.type === 'dhyan' && timerEnabled) {
							MediaPlayer.instance().showTimerView();
						} else {
							MediaPlayer.instance().playAudio(href!, routeState.type, 0);
						}
						history.navigate('/');
					}}
				>
					{routeState.type === 'dhyan' || routeState.type === 'sandesh' ? <HomePage /> : <ArticleList recordType={routeState.type} />}
				</Page>
			) : (
				<span></span>
			)}
		</React.Fragment>
	);
}

export default withRouter(MediaPage);
